// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { AddToCartReadyToGoRingNewCustomerResponseFragmentDoc } from '../fragments/addToCartReadyToGoRingNewCustomerResponse.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const AddToCartReadyToGoRingNewCustomerDocument = gql`
    mutation addToCartReadyToGoRingNewCustomer($input: AddToCartReadyToGoRingInput!, $customer: CustomerRegistrationInput!, $isConsultant: Boolean!) {
  addToCartReadyToGoRingNewCustomer(input: $input, customer: $customer) {
    ...addToCartReadyToGoRingNewCustomerResponse
  }
}
    ${AddToCartReadyToGoRingNewCustomerResponseFragmentDoc}`;

export function useAddToCartReadyToGoRingNewCustomerMutation() {
  return Urql.useMutation<SchemaTypes.AddToCartReadyToGoRingNewCustomerMutation, SchemaTypes.AddToCartReadyToGoRingNewCustomerMutationVariables>(AddToCartReadyToGoRingNewCustomerDocument);
};